module.exports = __webpack_public_path__ + "static/media/shot_200831_115805.f5bdd8ad.png";